import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { LoadingScreen } from "components/partials/loading-screen/loading-screen";

import { useCurrentClient } from "hooks/api/use-clients";
import { useCurrentCampaign } from "hooks/api/use-campaigns";
import { useCurrentTouchpoint } from "hooks/api/use-current-touchpoint";
import { BuilderContentProvider, useTouchpointVersion } from "hooks/api/use-touchpoint-versions";

import { Route } from "utilities/app-routes";

const BuilderProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const client = useCurrentClient();
  const campaign = useCurrentCampaign();
  const touchpoint = useCurrentTouchpoint();
  const { versionId: builderId } = useParams<{ versionId: string }>();
  const navigate = useNavigate();
  const { data: builderContent, isError } = useTouchpointVersion({
    clientId: client.id,
    campaignId: campaign.id,
    touchpointId: touchpoint.id,
    id: builderId,
  });

  useEffect(() => {
    if (isError) {
      navigate(Route.notFound);
    }
  }, [isError, navigate]);

  if (!builderContent || builderId !== builderContent.id) {
    return <LoadingScreen />;
  }

  return <BuilderContentProvider value={builderContent}>{children}</BuilderContentProvider>;
};

export default BuilderProvider;
